import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.update();
  }

  update() {
    this.label.classList.toggle("checked", this.checked);
  }

  get checked() {
    return this.element.checked;
  }

  get label() {
    return this.element.parentElement;
  }
}
